import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle, ArrowLeft, RotateCcw } from 'lucide-react';

export const PaymentCanceled: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-amber-50 to-orange-50 p-4">
      <Card className="w-full max-w-md border-amber-200">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-4">
            <XCircle className="w-8 h-8 text-amber-600" />
          </div>
          <CardTitle className="text-2xl text-amber-800">
            Paiement annulé
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6 text-center">
          <div className="space-y-2">
            <p className="text-amber-700 font-medium">
              Votre paiement a été annulé
            </p>
            <p className="text-sm text-muted-foreground">
              Aucun montant n'a été débité de votre compte
            </p>
          </div>
          
          <div className="bg-amber-50 p-4 rounded-lg border border-amber-200">
            <p className="text-sm text-amber-700">
              Vous pouvez réessayer le paiement à tout moment pour débloquer toutes les fonctionnalités premium
            </p>
          </div>

          <div className="space-y-3">
            <Button 
              onClick={() => navigate('/subscription')}
              className="w-full bg-primary hover:bg-primary/90"
              size="lg"
            >
              <RotateCcw className="w-4 h-4 mr-2" />
              Réessayer le paiement
            </Button>
            
            <Button 
              onClick={() => navigate('/dashboard')}
              variant="outline"
              className="w-full"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Retour au dashboard
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};